import { axiosMicroservice } from 'src/api/axios';

export type TpFeatureFlags = {
  paymentSystem: string;
  cancellation: boolean;
  pause: boolean;
  upgrade: boolean;
  lifetime: boolean;
};

export const getUserFeatureFlags = async ({
  userId,
  email,
  app = 'FaceYoga',
}: {
  userId: string;
  email: string;
  app?: string;
}): Promise<TpFeatureFlags> => {
  const { data } = await axiosMicroservice.get(
    `feature_flags?user_id=${userId}&email=${encodeURIComponent(email.replace(/ /g, '+'))}&app=${app}`,
  );
  return data;
};
